import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {AuthenticationService} from '../../../../core/services/authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PopupHelperService} from '../../../../core/services/popup-helper.service';
import {StorageService} from "../../../../core/services/storage.service";
import {NgClass} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {CustomInputComponent} from "../../../../shared/components/custom-input/custom-input.component";
import {ValidationErrorComponent} from "../../../../shared/components/app-validation-error/validation-error.component";
import {PrimaryButtonComponent} from "../../../../shared/components/primary-button/primary-button.component";
import {HttpService} from "../../../../core/services/http.service";
import {environment} from '@shared-environments/environment';
import {IconModule} from "../../../../../../shared/assets/icons/ts/icon.module";
import {InputPasswordComponent} from "@cybfed/ui-lib/forms/text-inputs/input-password/input-password.component";

@Component({
  selector: 'app-auth-signup-general',
  templateUrl: './auth-signup.component.html',
  standalone: true,
  imports: [
    NgClass,
    TranslateModule,
    ValidationErrorComponent,
    FormsModule,
    IconModule,
    ReactiveFormsModule,
    InputPasswordComponent
  ],
  providers: [AuthenticationService, PopupHelperService, HttpService],
  styleUrls: ['./auth-signup.component.scss']
})
export class AuthSignupComponent implements OnInit {
  @Input() showBg = true;
  @Output() changeTub = new EventEmitter();
  @Output() closeModal = new EventEmitter();
  @Input() currentStep: any = 0;
  @Input() shouldRouting: boolean = true;

  registerForm: any;
  private passwordValidator = /^[\x00-\xFF]*$/;
  loginWithFacebookUrl: string = environment.apiURL + "/auth/facebook"
  loginWithVkUrl: string = environment.apiURL + "/auth/vk"
  loginWithSteamUrl: string = environment.apiURL + "/auth/steam"
  loginWithTwitchUrl: string = environment.apiURL + "/auth/twitch"
  loginWithGoogleUrl: string = environment.apiURL + "/auth/google"
  private submited: any = false;

  constructor(private formBuilder: FormBuilder,
              private authenticationService: AuthenticationService,
              private router: Router,
              private route: ActivatedRoute,
              private popupHelperService: PopupHelperService) { }

  ngOnInit(): void {
    const password = new FormControl('', [
      Validators.minLength(5), Validators.maxLength(30), Validators.pattern(this.passwordValidator)]);
    const confirmPassword = new FormControl('', [
      Validators.minLength(5), Validators.maxLength(30), Validators.pattern(this.passwordValidator)]);
    this.registerForm = new FormGroup({
      password,
      confirmPassword,
      nickname: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(12)]),
      email: new FormControl('', [Validators.required, Validators.minLength(2),Validators.email]),
    });

  }

  onSubmit(): any {
    if (this.submited){
      return
    }
    this.submited = true
    const registerData = this.registerForm.value;


    if (this.registerForm.invalid){
      this.submited = false
      for (const key in this.registerForm.controls) {
        if (this.registerForm.controls[key].untouched && !this.registerForm.controls[key].value) {
          this.registerForm.controls[key].markAsTouched();
          this.registerForm.controls[key].setValue(1);
          this.registerForm.controls[key].setValue('');
        }
      }
      return false;
    }else{
      this.authenticationService.registration({ email: registerData.email,
        nickname:registerData.nickname,
        referral: StorageService.getItem('referral'),
        ownerPublisherId: StorageService.getItem(StorageService.statics.ownerPublisherId),
        password: registerData.password}).subscribe( (data:any) => {
        this.submited = false
        if (!data.hasError) {
          this.closeModal.emit()
          this.router.navigate(['/auth/informative/page'],  { queryParams:
              {
                status: 'success',
                title: 'confirm_your_mail',
                description: 'for_activate_confirm_your_mail',
                email: registerData.email
              } })
        } else {
          this.popupHelperService.printError({text:data.errorMessages[0].msg});
        }
      });
    }
  }

  changeModalTub(){
    this.changeTub.emit('signin')
    if (this.shouldRouting) {
      this.router.navigate(["../signin"], { relativeTo: this.route });
    }
  }

}
